import script from "./BannerEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerEdit.vue?vue&type=script&setup=true&lang=js"

import "./BannerEdit.vue?vue&type=style&index=0&id=3ce4875a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce4875a"]])

export default __exports__